import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ADMIN,
  GET_ADMIN_ONE,
  DELETE_ADMIN,
  UPDATE_ADMIN,
  ADD_NEW_ADMIN,
} from "./actionType";

import {
  getAdminSuccess,
  getAdminFail,
  deleteAdminSuccess,
  deleteAdminFail,
  updateAdminSuccess,
  updateAdminFail,
  addAdminSuccess,
  addAdminFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAdminApi,
  getAdminApi,
  updateAdminApi,
  deleteAdminApi,
  addNewAdminApi,
  getOneAdminApi
} from "../../helpers/backend_helper";

function* getAdmin({ payload: admin }) {
  try {
    const response = yield call(getAdminApi, admin);
    yield put(getAdminSuccess(GET_ADMIN, response.data));
  } catch (error) {
    yield put(getAdminFail(GET_ADMIN, error));
  }
}

function* getAdminOne({ payload: id }) {
  try {
    const response = yield call(getOneAdminApi, id);
    yield put(getAdminSuccess(GET_ADMIN_ONE, response.data));
  } catch (error) {
    yield put(getAdminFail(GET_ADMIN_ONE, error));
  }
}

function* onUpdateAdmin({ payload: admin }) {
  try {
    if (admin.setApprove) {
      const response = yield call(approveAdminApi, admin);
      yield put(updateAdminSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAdminApi, admin);
      yield put(updateAdminSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAdminFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAdmin({ payload: admin }) {
  try {
    const response = yield call(deleteAdminApi, admin);
    yield put(deleteAdminSuccess({ admin, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAdminFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAdmin({ payload: admin }) {
  try {
    const response = yield call(addNewAdminApi, admin);
    yield put(addAdminSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAdminFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAdmin() {
  yield takeEvery(GET_ADMIN, getAdmin);
}

export function* watchGetAdminOne() {
  yield takeEvery(GET_ADMIN_ONE, getAdminOne);
}

export function* watchUpdateAdmin() {
  yield takeEvery(UPDATE_ADMIN, onUpdateAdmin);
}

export function* watchDeleteAdmin() {
  yield takeEvery(DELETE_ADMIN, onDeleteAdmin);
}

export function* watchAddNewAdmin() {
  yield takeEvery(ADD_NEW_ADMIN, onAddNewAdmin);
}

function* adminSaga() {
  yield all([
    fork(watchGetAdmin),
    fork(watchGetAdminOne),
    fork(watchDeleteAdmin),
    fork(watchUpdateAdmin),
    fork(watchAddNewAdmin)
  ]);
}

export default adminSaga;
